export default __webpack_public_path__ + "static/media/time.2067470e.svg";